import { BeginnerModeLevel } from '@colonist/game-beginner-mode';
import { BotDifficulty, BotSpeedSettings, DiceSettingEnum, GameSpeedSettings, GameTypeEnum, MapSettingEnum, ModeSettingEnum } from '@colonist/game-base-types';
export function getMapForBeginnerModeLevel(level) {
    switch(level){
        case BeginnerModeLevel.Level1:
            return MapSettingEnum.CampaignLevel1;
        case BeginnerModeLevel.Level2:
            return MapSettingEnum.CampaignLevel2;
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`);
    }
}
export function getBotsForBeginnerModeLevel(level) {
    switch(level){
        case BeginnerModeLevel.Level1:
            return [];
        case BeginnerModeLevel.Level2:
            return [
                BotDifficulty.BotEasy
            ];
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`);
    }
}
export function getVPToWinForBeginnerModeLevel(level) {
    switch(level){
        case BeginnerModeLevel.Level1:
            return 4;
        case BeginnerModeLevel.Level2:
            return 5;
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`);
    }
}
export function getCardDiscardLimitForBeginnerModeLevel(level) {
    switch(level){
        case BeginnerModeLevel.Level1:
            return 20;
        case BeginnerModeLevel.Level2:
            return 7;
        case BeginnerModeLevel.End:
            throw new Error(`Invalid beginner mode level: ${level}`);
    }
}
export function getBeginnerModeContext(level, map) {
    const beginnerModeCreationContext = {
        gameTypeEnum: GameTypeEnum.BeginnerMode,
        gameSpeed: GameSpeedSettings.Base12000s,
        botSpeed: BotSpeedSettings.Normal,
        modeSetting: ModeSettingEnum.BeginnerModeClassic4P,
        diceSetting: DiceSettingEnum.Random,
        mapSetting: map,
        victoryPointsToWin: getVPToWinForBeginnerModeLevel(level),
        cardDiscardLimit: getCardDiscardLimitForBeginnerModeLevel(level)
    };
    return beginnerModeCreationContext;
}
export function getWaitMSForAction(baseMS, actionIndex) {
    const minimumMSActionIndex = 6;
    const minimumMS = baseMS / 3;
    if (actionIndex >= minimumMSActionIndex) return minimumMS;
    const reductionPerIndex = minimumMS / minimumMSActionIndex;
    return minimumMS + reductionPerIndex * (minimumMSActionIndex - actionIndex);
}
